// extracted by mini-css-extract-plugin
export default {"welcomePanelOverride":"ald_nebraska-theme__welcomePanelOverride__r8dR1"};